<template>
	<!-- begin #footer -->
	<div id="footer" class="footer" style="border-top: 0">
		&copy; 2022 Qtrust, All Rights Reserved. Version {{version}}
	</div>
	<!-- end #footer -->
</template>

<script>
import PageOptions from '@/Options/PageOptions.js'
import {version} from './../../../package.json'

export default {
  name: 'Footer',
  data() {
		return {
			pageOptions: PageOptions,
			version
		}
  }
}
</script>
